import React from 'react';
import { Users, MapPin } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="chi-siamo" className="bg-black py-28 border-t border-zinc-900">
      <div className="bb-container px-6">
        
        {/* SOPRATITOLO */}
        <span className="uppercase tracking-[0.5em] text-[10px] font-bold text-[#c49a45] block mb-4">
          DAL 2023
        </span>

        {/* GRIGLIA PRINCIPALE: Titolo e Video allineati in alto */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          
          {/* COLONNA SINISTRA: TITOLO E STORIA */}
          <div className="space-y-8">
            <div>
              <h2 className="bb-display text-5xl md:text-8xl text-white uppercase leading-[0.9] mb-8">
                IL <span className="text-[#c49a45]">BEER BATTLE</span>
              </h2>
              <h3 className="text-[#c49a45] font-black uppercase tracking-widest text-lg md:text-xl">
                VALENTINO ANGELINI & MARCO MARINI
              </h3>
            </div>
            
            <div className="space-y-6 text-zinc-400 text-sm md:text-base leading-relaxed tracking-wide">
              <p>
                <strong className="text-white">Il Beer Battle</strong> nasce nel 2023 da una visione condivisa. Un progetto forgiato dall'idea originale di <strong className="text-white">Valentino Angelini</strong> e sviluppato, 
                fin dai primi istanti, in totale sinergia con <strong className="text-white">Marco Marini</strong>.
              </p>

              <p>
                Entrambi homebrewers, Valentino e Marco hanno unito le forze per trasformare la passione e la sperimentazione casalinga in un’arena dove il confronto tecnico e la competizione si fondono. È un evento creato da chi 
                la birra la produce in casa, conoscendo bene la dedizione e la cura necessarie per ogni singola cotta, con l’obiettivo di dare valore al talento di ogni partecipante.
              </p>

              <p>
                Il legame con <strong className="text-white">Hilltop Brewery</strong> a Bassano Romano definisce la nostra identità: 
                siamo orgogliosi di essere ospitati in questa eccellenza brassicola fin dalla prima edizione, offrendo agli homebrewers 
                un palcoscenico di assoluto rilievo professionale dove mettere alla prova le proprie creazioni.
              </p>
            </div>
          </div>

          {/* COLONNA DESTRA: VIDEO E TESTO BERLO (Nomi in Giallo) */}
          <div className="space-y-8">
            {/* BOX VIDEO CON VELO SCURO */}
            <div className="relative border border-zinc-800 p-1 bg-zinc-900 shadow-2xl">
              <div className="absolute inset-0 bg-black/40 z-10 pointer-events-none" />
              
              <video 
                className="w-full aspect-video object-cover"
                controls
                poster="/assets/Luppolo.webp"
              >
                <source src="/assets/Intervista ValeeMarco.mp4" type="video/mp4" />
                Il tuo browser non supporta il tag video.
              </video>
            </div>

            {/* TESTO BERLO CON NOMI IN GIALLO E LINEA LATERALE */}
            <div className="border-l-2 border-[#c49a45] pl-6 py-1">
              <span className="text-[#c49a45] text-[10px] font-black uppercase tracking-[0.4em] block mb-4">
                Media Storytelling
              </span>
              <p className="text-zinc-300 text-sm leading-relaxed mb-6 italic">
                In occasione della 3° edizione, le telecamere di <span className="text-[#c49a45] font-bold">Berlo</span> sono entrate nel cuore dell'Arena per documentare l'essenza della competizione. Attraverso le parole di <span className="text-[#c49a45] font-bold">Valentino</span> e <span className="text-[#c49a45] font-bold">Marco</span>, questo estratto racconta la dedizione tecnica e lo spirito di condivisione che animano Hilltop Brewery durante l'evento.
              </p>
              
              <div className="space-y-4">
                <p className="text-zinc-500 text-[10px] uppercase tracking-wider">
                  Ringraziamo Berlo per l'eccezionale lavoro di narrazione.
                </p>
                <a 
                  href="https://youtu.be/5QRJ5PzjTfU?si=zMS4HkPSzaPqOMlU" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block text-[#c49a45] text-[10px] font-bold uppercase tracking-widest hover:text-white transition-colors border-b border-[#c49a45]/30 pb-1"
                >
                  Guarda il reportage integrale su YouTube →
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER DELLA SEZIONE */}
        <div className="mt-16 pt-8 border-t border-zinc-900 flex flex-wrap gap-8">
          <div className="flex items-center gap-3">
            <Users size={16} className="text-[#c49a45]" />
            <span className="text-[10px] text-zinc-500 uppercase tracking-widest font-bold">Fondatori</span>
          </div>
          <div className="flex items-center gap-3">
            <MapPin size={16} className="text-[#c49a45]" />
            <span className="text-[10px] text-zinc-500 uppercase tracking-widest font-bold">Bassano Romano</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;